import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import useScrollToAnchor from '@segment/utils/useScrollToAnchor'

const data = {
  heading: `Customers rank Segment`,
  columns: [
    {
      heading: `4 or 5`,
      description: `Star rating from 500+ reviews`,
    },
    {
      heading: `90%`,
      description: `Rate Segment as easy to use`,
    },
    {
      heading: `91%`,
      description: `of Segment customers are likely to recommend`,
    },
  ],
  subheading: `Read the full report to see why.`,
  button: {
    text: `Get the full report`,
  },
}

const CustomersRankSegment: FC = () => {
  const scrollTo = useScrollToAnchor(`form-wrapper`, -96)

  return (
    <StyledSectionBase variant="centered">
      <StyledSectionCopy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {data.heading}
          </CopyText.Heading>
        </CopyTextBase>
        <StyledColumnTrack
          overrides={{
            md: 3,
          }}
        >
          {data.columns.map(({ heading, description }, index) => (
            <CopyTextBase key={index} centered={true}>
              <CopyText.Heading tag="h3" variant="h2">
                {heading}
              </CopyText.Heading>
              <CopyText.Description tag="p" variant="pLarge">
                {description}
              </CopyText.Description>
            </CopyTextBase>
          ))}
        </StyledColumnTrack>
      </StyledSectionCopy>
      <Section.Contents>
        <CopyTextBase centered={true}>
          <StyledSubheading tag="h3" variant="h4">
            {data.subheading}
          </StyledSubheading>
          <Button size="large" color="primary" variant="filled" tag="a" onClick={scrollTo}>
            {data.button.text}
          </Button>
        </CopyTextBase>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 24px;

    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding-top: 40px;
    }
  }
`

const StyledSubheading = styled(CopyText.Heading)`
  margin-bottom: 32px;
`

const StyledColumnTrack = styled(ColumnTrack)`
  width: 100%;
  margin-top: 56px;
`

const StyledSectionCopy = styled(Section.Copy)`
  max-width: 1000px;
`

export default CustomersRankSegment
